import styled from '@emotion/styled';
import { LIGHT_BLUE, GREY, APP_TEMA, WHITE, BEI_JYO } from '../../styles/color';

export const BannerManageLayout = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
  border-radius: 10px;
  width: 100%;
  text-align: center;
  padding-bottom: 100px;
`;

export const BannerManageBody = styled.div`
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 20px;
  
  @media (max-width: 768px) {
    padding: 0 10px;
  }
`;

export const Title = styled.h2`
  margin-left: 20px;
  margin-right: 20px;
  color: ${LIGHT_BLUE};
  text-align: left;
  margin-bottom: 20px;
`;

export const StyledCard = styled.div`
  background-color: ${WHITE};
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 20px;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  background-color: ${APP_TEMA};
  color: ${WHITE};
  padding: 12px 15px;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 576px) {
    font-size: 14px;
    padding: 10px 12px;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
`;

export const CardBody = styled.div`
  padding: 15px;
  background-color: ${BEI_JYO};
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  background-color: ${BEI_JYO};
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: ${BEI_JYO};
  font-size: 14px;
  
  @media (max-width: 768px) {
    font-size: 12px;
  }
  
  th {
    background-color: ${APP_TEMA};
    color: ${WHITE};
    padding: 10px 8px;
    text-align: left;
    white-space: nowrap;
    border-bottom: 2px solid ${GREY};
  }
  
  td {
    padding: 8px;
    border-bottom: 1px solid ${GREY};
    vertical-align: middle;
  }
  
  tr:nth-of-type(even) {
    background-color: ${WHITE};
  }
  
  tr:hover {
    background-color: #e8f4ff;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
  
  @media (max-width: 576px) {
    flex-direction: column;
    width: 100%;
    
    button {
      width: 100%;
    }
  }
`;

export const MoveButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
`;

export const PreviewImage = styled.div`
  width: 100px;
  height: 50px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 4px;
  border: 1px solid ${GREY};
  
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  
  @media (max-width: 576px) {
    width: 60px;
    height: 35px;
  }
`;

export const FormControl = styled.input`
  width: 100%;
  padding: 6px 8px;
  font-size: 13px;
  border: 1px solid ${GREY};
  border-radius: 4px;
  
  &:focus {
    outline: none;
    border-color: ${LIGHT_BLUE};
    box-shadow: 0 0 0 2px rgba(0, 149, 255, 0.2);
  }
  
  @media (max-width: 576px) {
    font-size: 11px;
    padding: 4px 6px;
  }
`;

export const SmallButton = styled.button`
  padding: 4px 8px;
  font-size: 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: ${props => props.variant === 'danger' ? '#e33737' : LIGHT_BLUE};
  color: ${WHITE};
  
  &:hover {
    background-color: ${props => props.variant === 'danger' ? '#c62828' : '#007ACC'};
  }
  
  &:disabled {
    background-color: ${GREY};
    cursor: not-allowed;
  }
`;

export const UploadButton = styled(SmallButton)`
  margin-top: 4px;
  width: 100%;
`;

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  background: ${WHITE};
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  width: 90%;
`;

export const SectionTitle = styled.h3`
  color: ${LIGHT_BLUE};
  font-size: 16px;
  margin-bottom: 15px;
  text-align: left;
`;

export const Instructions = styled.ul`
  text-align: left;
  padding-left: 20px;
  
  li {
    margin-bottom: 8px;
    line-height: 1.5;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
  
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const TextMuted = styled.span`
  color: ${GREY};
  font-size: 13px;
`;
